import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { brand } from '../theme';

export default function CTASection({
  eyebrow = 'Ready when you are',
  title = 'Bring intelligent operations to your business.',
  subtitle = 'Tell us what you do and we’ll show you exactly how Concierge fits in.',
  primaryCta = { label: 'Book a 20-min demo', to: '/contact' },
  secondaryCta = { label: 'Explore Concierge', to: '/concierge' },
}) {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 4,
            bgcolor: brand.navy,
            color: '#fff',
            p: { xs: 5, md: 8 },
            textAlign: 'center',
          }}
        >
          <Box
            aria-hidden
            sx={{
              position: 'absolute',
              inset: 0,
              background: brand.ctaPanelGradient,
            }}
          />
          <Box sx={{ position: 'relative' }}>
            <Typography
              variant="overline"
              sx={{
                color: brand.blueLight,
                letterSpacing: '0.18em',
                fontWeight: 700,
              }}
            >
              {eyebrow}
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: '#fff',
                fontSize: { xs: '1.9rem', md: '2.6rem' },
                mt: 1.5,
                mb: 2,
                maxWidth: 720,
                mx: 'auto',
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: '#CBD5E1', maxWidth: 620, mx: 'auto', mb: 4 }}
            >
              {subtitle}
            </Typography>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
            >
              <Button
                component={RouterLink}
                to={primaryCta.to}
                variant="contained"
                color="primary"
                size="large"
                endIcon={<ArrowForwardRoundedIcon />}
                sx={{ px: 3.5, py: 1.4 }}
              >
                {primaryCta.label}
              </Button>
              {secondaryCta && (
                <Button
                  component={RouterLink}
                  to={secondaryCta.to}
                  variant="outlined"
                  size="large"
                  sx={{
                    color: '#fff',
                    borderColor: 'rgba(255,255,255,0.35)',
                    px: 3.5,
                    py: 1.4,
                    '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.06)' },
                  }}
                >
                  {secondaryCta.label}
                </Button>
              )}
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
